import { TIMEZONE_ALIAS_MAP } from '@/timezoneAliasMap';

export function normalizeTimeZone (tz) {
  return TIMEZONE_ALIAS_MAP[tz] || tz;
}

export function getTimeZone () {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return normalizeTimeZone(tz);
}
